import { inject, Injectable, signal } from '@angular/core';
import { filter } from 'rxjs/operators';
import { LocalStorageID } from '../../../local-storage/entities/local-storage-ids.entity';
import { LocalStorageStateService } from '../../../local-storage/state-machines/local-storage-state.service';

@Injectable({ providedIn: 'root' })
export class ListViewStateService {
    private readonly LOCAL_STORAGE_ID: LocalStorageID = LocalStorageID.Columns;

    private readonly localStorageStateService: LocalStorageStateService = inject(LocalStorageStateService);

    // Signals
    private readonly listViewState = signal<Record<string, string[]>>({});

    constructor() {
        this.localStorageStateService.isInitialized$
            .pipe(filter(isInitialized => isInitialized))
            .subscribe(() => this.loadLocalStorageState());
    }

    // #region Getters and Setters
    getListViewState(searchPageKey: string): string[] | undefined {
        return this.listViewState()[searchPageKey];
    }

    setListViewState(searchPageKey: string, visibleColumnKeys: string[]): void {
        this.listViewState.update(state => {
            const newState = { ...state };
            newState[searchPageKey] = visibleColumnKeys;
            return newState;
        });

        this.syncLocalStorageState(this.listViewState());
    }
    // #endregion

    // #region Load and Sync localStorage
    private loadLocalStorageState(): void {
        const storedState = this.localStorageStateService.getState(this.LOCAL_STORAGE_ID);

        if (storedState) {
            this.listViewState.set(storedState);
        }
    }

    private syncLocalStorageState(state: Record<string, string[]>): void {
        this.localStorageStateService.setState(this.LOCAL_STORAGE_ID, state);
    }
    // #endregion
}
